import React from 'react'
import { makeStyles, TextField } from '@material-ui/core/';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

const Filter = ({ onSearchChange, lang }) => {
  const useStyles = makeStyles({
    input: {
      fontSize: '14px',
      color: '#49586e'
    },
    icon: {
      color: '#49586e'
    },
    focus: {
      borderColor: '#49586e !important'
    },
  });

  const classes = useStyles();

  return (
    <TextField
      fullWidth
      InputProps={{
        classes: {
          input: classes.input,
          notchedOutline: classes.focus,
        },
        startAdornment:
          <InputAdornment position="start">
            <SearchIcon fontSize="large" className={ classes.icon }/>
          </InputAdornment>,
      }}
      variant="outlined"
      onChange={ onSearchChange }
      placeholder={ lang.q360_home_search_placeholder }
    />
  )
}

export default Filter;